export default {
    data() {
        return {
            blogs: [], //随笔列表
            todayStats: {},//今日数据
            currentTop: [],//最新
            readTop: [],//最多人喜欢
        }
    },
    async created() {
        await this.initData();
        this.getTodayStats();
    },

    methods: {

        //初始化数据
        async initData() {
            const { API, $request } = this;
            const url = API.getTopTen;
            const { data: res } = await $request(url, 'get');
            const data = res.data || {};
            if (res.code == 200) {
                this.currentTop = data.currentTop || [];
                this.readTop = data.readTop || [];
            }
        },

        //获取今日数据
        async getTodayStats() {
            const { API, $request } = this;
            const url = API.getTodayStats;
            const { data: res } = await $request(url, "get");
            this.todayStats = res.data || {
                今日访问量: "--",
                今日阅读量: "--",
                今日评论数: "--",
            };
        },
    }
}